module.exports = __webpack_public_path__ + "img/hr-H-T-4-unload-standup-shadow.ae1f8c5b.png";